import Modal from 'react-modal';
import {useState, createContext, useEffect} from 'react';
import { changeDisable, getPermission, getMaxValue, customFullModal, maskSN, viewLogOperation, isEqual, showMessageError} from '../../../classes/functions';
import './features.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import ListLog from '../../../components/ListLog';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaTrash, FaArrowAltCircleLeft, FaCog, FaPlus } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";

export default function Features(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);

  const [tabela, setTabela] = useState('');
  const [descricao, setDescricao] = useState('');
  const [observacao, setObservacao] = useState('');
  const [fluxo, setFluxo] = useState('');
  const [ativo, setAtivo] = useState('');
  const [rows, setRows] = useState([]);
  const [controls_balance, setControlsBalance] = useState('');
  const [active_link, setActiveLink] = useState('');
  const [obrigatorio, setObrigatorio] = useState('');
  const [formDescription, setFormDescription] = useState([]);
  const [rows_log, setRowsLog] = useState([]);
  const [formShareBalance, setFormShareBalance] = useState('');
  const [formOrdanation, setFormOrdenation] = useState('');
  const [rowsRemovidos, setRowsRemovidos] = useState([]);
  const [view_log, setViewLog] = useState({});
  const [view_old_log, setViewOldLog] = useState({});
  const [view_log_options, setViewLogOptions] = useState([]);
  const [view_log_old_options, setViewLogOldOptions] = useState([]);
  const [modalViewLog, setModalViewLog] = useState(false);

  useEffect(()=> {
    async function loadFeatures(){
      if (id) {
        getOne(id, option);
      } else {
        setCarrying(false);
      }
    }

    loadFeatures();

  },[]);

  function save(e){
    setCarrying(true);
    e.preventDefault();
    
    const data = {
      row: {
        tabela: tabela,
        descricao: descricao,
        observacao: observacao,
        fluxo: fluxo,
        ativo: ativo,
        controls_balance: controls_balance,
        active_link: active_link,
        obrigatorio: obrigatorio,
        rows: rows,
        rowsRemovidos: rowsRemovidos
      }
    }

    if (id) { 
      data.row.id = id;
      api.put("/api/features/put", data)
      .then((response) => {
          toast.success('Registro atualizado com sucesso.');
          history.push('/features');
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    } else {
      api.post("/api/features/post", data)
      .then((response) => {
          toast.success('Registro inserido com sucesso.');
          history.push('/features');
          setCarrying(false);
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function getOne(id, option){
    api.get("/api/features/getList?id=" + id)
    .then((response) => {
        setTabela(response.data.row.tabela);
        setDescricao(response.data.row.descricao);
        setObservacao(response.data.row.observacao);
        setFluxo(response.data.row.fluxo);
        setAtivo(response.data.row.ativo);
        setControlsBalance(response.data.row.controls_balance);
        setActiveLink(response.data.row.active_link);
        setObrigatorio(response.data.row.obrigatorio);
        setRows(sortList(response.data.rows));
        setRowsLog(response.data.rows_log);
        setCarrying(false);
      }
    ).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });

    setView(changeDisable(option));
  }

  function cancel(){
    history.push('/features');
  }
  
  function closeModal() {
    setModalViewLog(false);
  }
  
  function remove(){
    api.delete("/api/features/delete?id=" + id)
    .then((response) => {
        toast.success('Registro excluído com sucesso.');
        history.push('/features');
      }
    ).catch((error) => {
      showMessageError(error.response.data); 
    });
  }
  
  async function setGenericItem(index, value, field) 
  {
    let aux = [];
    
    rows.forEach((element, inx) => {
      if (inx == index) {
        if (field == 'share_balance') {
          if (element[field] == 'S') {
            element[field] = 'N';
            element.ordination = '';
          } else {
            element[field] = 'S';
            element.ordination = getMaxValue(rows, 'ordination');
          }
          setRows(() => sortList(aux));
        } else if (field == 'active') {
          element[field] = element[field] == 'S' ? 'N' : 'S';
          setRows(() => aux);
        } else {
          element[field] = value;
          setRows(() => aux);
        }
      }
      aux.push(element);
    });
  }
  
  function sortList(arr) {
    arr.sort(function(a, b) {
      var keyA = a.share_balance,
          keyB = b.share_balance;
      
      if (keyA < keyB) return 1;
      if (keyA > keyB) return -1;
      
      return 0;
    });
    
    arr.sort(function(a, b) {
      var keyA = parseInt(a.ordination),
          keyB = parseInt(b.ordination);
      
      if (b.share_balance != 'N') {
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
      }
      
      return 0;
    });
    
    arr.map((element,index) => {
      if (element.share_balance === 'S') {
        element.ordination = index + 1;
      }
    });
    
    return arr;
  }

  function rmDisableItem(index) {
  
  }
  
  function rmItem(index) {
    if (!view) {
      let newListRows = [];
      let newRowsRemovidos = [];

      rows.forEach((element, idx) => {
        if (index !== idx) {
          newListRows.push(element);
        } else {
          newRowsRemovidos.push(element);
        }
      });
      
      setRows(newListRows);
      setRowsRemovidos(newRowsRemovidos);
    }
  }
  
  function addItem() {
    if ((formDescription != '')) {
      rows.push({
        active: 'S',
        id_feature: id,
        description: formDescription,
        share_balance: 'N',
        ordination: '',
      });
        
      setRows(rows);
      setFormDescription('');
    } else {
      toast.error('Preencha todos os campos com * antes de adicionar item.');
    }
  }
  
  function normalizeLogItem() {
    setViewLogOptions([]);
    setViewLogOldOptions([]);
    
    if (view_log.dados?.options && view_old_log.dados?.options) {
      let list1 = view_log.dados?.options;
      let list2 = view_old_log.dados?.options;
      let aux1 = [];
      let aux2 = [];
      let aux = list1.length > list2.length ? list1.length : list2.length;
      
      for (let index = 0; index < aux; index++) {
        if (list1[index]?.id)
          delete list1[index].id;
        if (list2[index]?.id)
          delete list2[index].id;

        if (list1[index] && !list2[index]) {
          aux1.push(list1[index]);
        } else if (list2[index] && !list1[index]) {
          aux2.push(list2[index]);        
        } else if (!isEqual(list1[index], list2[index])) {
          aux1.push(list1[index]);
          aux2.push(list2[index]);
        }      
      }
      
      setViewLogOptions(aux1);
      setViewLogOldOptions(aux2);
    } else if (view_log.dados?.options) {
      setViewLogOptions(view_log.dados?.options);
    }
  }

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Cadastro de Características">
          <Link to="/features">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais</h2>
              <hr></hr>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Descrição</label><br/>
                  <input type="text" placeholder="Descrição" value={descricao} onChange={ (e) => setDescricao(e.target.value) } maxLength="100" disabled={view || id}/>
                </div>
                <div className="formDiv">
                  <label>Valor</label><br/>
                  <input type="text" placeholder="Valor" value={fluxo} onChange={ (e) => setFluxo(e.target.value) } maxLength="100" disabled={view}/>
                </div>
                <div className="formDiv">
                  <label>Ativo</label><br/>
                  <select value={ativo} onChange={ (e) => setAtivo(e.target.value) } disabled={view}>
                    <option>Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
              </div>
              <div className="divGroup">
                <div className="formDiv">
                  <label>Controla Saldo</label><br/>
                  <select value={controls_balance} onChange={ (e) => setControlsBalance(e.target.value) } disabled={view}>
                    <option>Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
                <div className="formDiv">
                  <label>Obrigatorio</label><br/>
                  <select value={obrigatorio} onChange={ (e) => setObrigatorio(e.target.value) } disabled={view}>
                    <option>Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
                <div className="formDiv">
                  <label>Associar Produto Automático</label><br/>
                  <select value={active_link} onChange={ (e) => setActiveLink(e.target.value) } disabled={view}>
                    <option>Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
              </div>
            </div>
            <br />
            <div className="containerGroupData">
              <h2>Registros</h2>
              <hr></hr>
              <div className="divGroup">
                <div className="formDiv">
                  <table>
                    <tr>
                      {controls_balance == 'S' && <th scope="col" style={{width: '15%'}}>
                        Ordem
                      </th>}
                      <th scope="col" className='collumOption'>Ativar</th>
                      {controls_balance == 'S' && <th scope="col" className='collumOption'>
                        Compartilha Saldo
                      </th>}
                      <th scope="col">Descrição</th>
                      <th scope="col" className='collumOption'></th>
                    </tr>
                    <tr>
                      {controls_balance == 'S' && <td colSpan={4}>
                        <input type="text" placeholder="Descrição" value={formDescription} onChange={ (e) => setFormDescription(e.target.value) } maxLength="60" disabled={view}/>
                      </td>}
                      {controls_balance == 'N' && <td colSpan={2}>
                        <input type="text" placeholder="Descrição" value={formDescription} onChange={ (e) => setFormDescription(e.target.value) } maxLength="60" disabled={view}/>
                      </td>}
                      <td> 
                        <Link className="action" onClick={ (e) => addItem() } >
                          <FaPlus color="#001675" size={17} />
                        </Link>
                      </td> 
                    </tr>
                    {rows.map((item, index)=>{
                      return(
                        <tr key={index}>
                          {controls_balance == 'S' && <td>
                            {/* {item.share_balance == 'S' && <FaArrowCircleUp onClick={changeOrdenation(index, 'plus')}/>}&nbsp;
                            {item.share_balance == 'S' && <FaArrowCircleDown onClick={changeOrdenation(index, 'minus')}/>} */}
                            <input type="text" placeholder="Ordem" value={item.ordination} onChange={ (e) => setGenericItem(index, e.target.value, 'ordination') } maxLength="60" disabled={item.share_balance != 'S'} />
                          </td>}
                          <td>
                            <input type="checkbox" checked={item.active == 'S'} value={item.id} onChange={(e) => setGenericItem(index, e.target.value, 'active')}/>
                          </td>
                          {controls_balance == 'S' && <td>
                            <input type="checkbox" checked={item.share_balance == 'S'} value={item.id} onChange={(e) => setGenericItem(index, e.target.value, 'share_balance')}/>
                          </td>}
                          <td>
                            <input type="text" placeholder="Chave" value={item.description} onChange={ (e) => setGenericItem(index, e.target.value, 'description') } maxLength="60" disabled />
                          </td>
                          <td data-label="Opções">
                            <Link className="action" onClick={ (e) => rmItem(index) } >
                              <FaTrash color="#001675" size={17} />
                            </Link>
                          </td> 
                        </tr>
                      )
                    })}
                  </table>
                </div>
                <div className="formDiv"></div>
              </div>
            </div>
            {!view && <div className="formDiv">
              {getPermission('CONFIGURACOES - TABELAS GENERICAS - CADASTRO') && <button type="submit" className="buttonSubmit" onClick={save} disabled={view}>Salvar</button>}
              <button type="button" className="buttonCancel" onClick={cancel} disabled={view}>Cancelar</button>
              {getPermission('CONFIGURACOES - TABELAS GENERICAS - EXCLUSAO') && <button type="button" className="buttonRemove" onClick={remove} disabled={view}>Excluir</button>}
            </div>}
          </form>
        </div>
        <ListLog listItems={rows_log} setViewLog={setViewLog} setViewOldLog={setViewOldLog} setModalViewLog={setModalViewLog}></ListLog>
      </div>}
      
      <Modal  
        isOpen={modalViewLog}
        onAfterOpen={normalizeLogItem}
        onRequestClose={closeModal}
        style={customFullModal}
        contentLabel="Origem"
        ariaHideApp={false}
        keepMounted
      >
        <div className="body-modal">
          <div className="divGroup">
            <h2>Log - {viewLogOperation(view_log.operacao)}</h2>
          </div>
          <div className="divGroup">
            <h3>Usuário {view_log.user}</h3>
          </div>
          <div className="divGroup">
            <div className="formDiv">
              <table>
                <thead>
                  <th>Campo</th>
                  {view_old_log?.data && <th>Valor em {view_old_log?.data} - {view_old_log.hora}</th>}
                  <th>Valor em {view_log.data} - {view_log.hora}</th>
                </thead>
                <tbody>
                  <tr>
                    <td>Descrição</td>
                    {view_old_log.data && <td>{view_old_log.dados?.row?.descricao}</td>}
                    <td>{view_log.dados?.row?.descricao}</td>
                  </tr>
                  { view_log.dados?.row?.fluxo !== view_old_log.dados?.row?.fluxo &&
                  <tr>
                    <td>Valor</td>
                    {view_old_log.data && <td>{view_old_log.dados?.row?.fluxo}</td>}
                    <td>{view_log.dados?.row?.fluxo}</td>
                  </tr>}
                  {view_log.dados?.row?.ativo !== view_old_log.dados?.row?.ativo &&
                  <tr>
                    <td>Ativo</td>
                    {view_old_log.data && <td>{maskSN(view_old_log.dados?.row?.ativo)}</td>}
                    <td>{maskSN(view_log.dados?.row?.ativo)}</td>
                  </tr>}
                  {view_log.dados?.row?.controls_balance !== view_old_log.dados?.row?.controls_balance &&
                  <tr>
                    <td>Controla Saldo</td>
                    {view_old_log.data && <td>{maskSN(view_old_log.dados?.row?.controls_balance)}</td>}
                    <td>{maskSN(view_log.dados?.row?.controls_balance)}</td>
                  </tr>}
                  {view_log.dados?.row?.obrigatorio !== view_old_log.dados?.row?.obrigatorio &&
                  <tr>
                    <td>Obrigatorio</td>
                    {view_old_log.data && <td>{maskSN(view_old_log.dados?.row?.obrigatorio)}</td>}
                    <td>{maskSN(view_log.dados?.row?.obrigatorio)}</td>
                  </tr>}
                  {view_log.dados?.row?.active_link !== view_old_log.dados?.row?.active_link &&
                  <tr>
                    <td>Associar Produto Automático</td>
                    {view_old_log.data && <td>{maskSN(view_old_log.dados?.row?.active_link)}</td>}
                    <td>{maskSN(view_log.dados?.row?.active_link)}</td>
                  </tr>}
                </tbody>
              </table>
            </div>
          </div>
          {(view_log_options.length > 0 || view_log_old_options.length > 0) && <h3>Itens</h3>}
          <div className="divGroup">
            <div className="formDiv">
              {(view_log_options.length > 0 || view_log_old_options.length) > 0 && <table>
                <thead>
                  <th>Descrição</th>
                  <th>Ativo</th>
                  <th>Compartilha Saldo</th>
                  <th>Prioridade</th>
                </thead>
                <tbody>
                  {view_log_old_options.map((item, index) => {
                    return (
                      <tr>
                        <td>{item.description}</td>
                        <td>{maskSN(item.active)}</td>
                        <td>{maskSN(item.share_balance)}</td>
                        <td>{item.ordination}</td>
                      </tr>
                    )
                  })}
                  {view_log_old_options.length == 0 && <tr>
                    <td colSpan={4}>&nbsp;</td>
                  </tr>}
                </tbody>
              </table>}
            </div>
            <div className="formDiv">
              {(view_log_options.length > 0 || view_log_old_options.length > 0) && <table>
                <thead>
                  <th>Descrição</th>
                  <th>Ativo</th>
                  <th>Compartilha Saldo</th>
                  <th>Prioridade</th>
                </thead>
                <tbody>
                  {view_log_options.map((item, index) => {
                    return (
                      <tr>
                        <td>{item.description}</td>
                        <td>{maskSN(item.active)}</td>
                        <td>{maskSN(item.share_balance)}</td>
                        <td>{item.ordination}</td>
                      </tr>
                    )
                  })}
                  {view_log_options.length == 0 && <tr>
                    <td colSpan={4}>&nbsp;</td>
                  </tr>}
                </tbody>
              </table>}
            </div>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonCancel" onClick={closeModal} disabled={view}>Fechar</button>
          </div>
        </div>
      </Modal>
    </div>    
  )
}